import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'

const numericValue = z
  .union([z.number(), z.string()])
  .transform(value => Number(value))
  .refine(value => Number.isFinite(value), 'Valor numérico inválido')

export const ruralPropertyActivityObject = z.object({
  id: z.string().uuid(),
  ruralPropertyId: z.string().uuid(),
  activityType: z.string().max(30),
  productivityPerHectare: numericValue.nullish(),
  productivityUnit: z.string().max(50).nullish(),
  annualRevenue: numericValue.nullish(),
  hectaresCultivated: numericValue.nullish(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export const ruralPropertyActivityUpsertInputObject = z.object({
  id: z.string().uuid().nullish(),
  ruralPropertyId: z.string().uuid(),
  activityType: z.string().max(30),
  productivityPerHectare: numericValue.nullish(),
  productivityUnit: z.string().max(50).nullish(),
  annualRevenue: numericValue.nullish(),
  hectaresCultivated: numericValue.nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
})

export type RuralPropertyActivityType = z.infer<typeof ruralPropertyActivityObject>
export type RuralPropertyActivityUpsertInput = z.infer<typeof ruralPropertyActivityUpsertInputObject>
